/* eslint-disable no-var, prefer-arrow-callback */

'use strict';

$(document).ready(function () {
    $('body').on('dataLayer:event', function (event) {
        if (!window.dataLayer) {
            window.console.error('no dataLayer found');
            return;
        }
        window.dataLayer.push(event.detail);
    });
});
